import React from 'react'

const STEPS = [
  { label: 'Select Inspiration', icon: 'images' },
  { label: 'Configure', icon: 'sliders' },
  { label: 'Choose Variant', icon: 'table-cells' },
  { label: 'Result', icon: 'wand-sparkles' },
]

type Props = {
  currentStep: number
}

export function WizardHeader({ currentStep }: Props) {
  return (
    <div className="flex items-center justify-between px-8 py-4 border-b border-gray-200 bg-white flex-shrink-0">
      <div className="flex items-center gap-2">
        <i className="fa fa-wand-sparkles text-purple-600 text-xl" />
        <span className="text-xl font-bold text-gray-900">AI Studio</span>
      </div>

      <div className="flex items-center gap-0">
        {STEPS.map((step, index) => {
          const isComplete = index < currentStep
          const isActive = index === currentStep

          return (
            <React.Fragment key={step.label}>
              <div className="flex items-center gap-2">
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold transition-colors ${
                    isComplete
                      ? 'bg-purple-600 text-white'
                      : isActive
                      ? 'bg-purple-100 text-purple-700 ring-2 ring-purple-600'
                      : 'bg-gray-100 text-gray-400'
                  }`}
                >
                  {isComplete ? <i className="fa fa-check text-xs" /> : <span>{index + 1}</span>}
                </div>
                <span
                  className={`text-sm font-medium whitespace-nowrap ${
                    isActive ? 'text-purple-700' : isComplete ? 'text-gray-700' : 'text-gray-400'
                  }`}
                >
                  {step.label}
                </span>
              </div>

              {index < STEPS.length - 1 && (
                <div
                  className={`w-12 h-0.5 mx-2 transition-colors ${
                    index < currentStep ? 'bg-purple-600' : 'bg-gray-200'
                  }`}
                />
              )}
            </React.Fragment>
          )
        })}
      </div>

      {/* Spacer to balance the layout */}
      <div className="w-32" />
    </div>
  )
}
